import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Unlock: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 12.7857C3 11.2472 4.20883 10 5.7 10H18.3C19.7912 10 21 11.2472 21 12.7857V20.2143C21 21.7528 19.7912 23 18.3 23H5.7C4.20883 23 3 21.7528 3 20.2143V12.7857Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M5 6C5 6.55228 5.44772 7 6 7C6.55228 7 7 6.55228 7 6H5ZM10 2H14V0H10V2ZM17 5V10H19V5H17ZM7 6V4.99992H5V6H7ZM14 2C15.6569 2 17 3.34315 17 5H19C19 2.23858 16.7614 0 14 0V2ZM10 0C7.2386 0 5 2.23848 5 4.99992H7C7 3.34309 8.34312 2 10 2V0Z"
        fill={color}
      />
      <path
        d="M12 15V18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Unlock;
